export interface ChangelogEntry {
  version: string;
  date: string;
  changes: string[];
}

export const changelog: ChangelogEntry[] = [
  {
    version: '1.4.1',
    date: '2026-03-08',
    changes: [
      'Fixed chat suggestion regex bug that could miss matches on re-render',
      'Error feedback on watering schedule save failures',
      'Buttons disable during save to prevent duplicate writes',
      'Settings now shows a "What\'s New" changelog',
      'City input sanitized for prompt safety',
    ],
  },
  {
    version: '1.4.0',
    date: '2026-03-08',
    changes: [
      'Smart watering schedules with per-plant intervals',
      'City-based climate zones for seasonal adjustment',
      'Chat suggestions — AI can recommend watering changes',
      'Check for updates in Settings',
    ],
  },
  {
    version: '1.3.0',
    date: '2026-03-07',
    changes: [
      'Drag-and-drop plant reordering',
      'Custom sort order for your collection',
    ],
  },
  {
    version: '1.2.0',
    date: '2026-03-05',
    changes: [
      'Activity logging — track watering, feeding, pruning, and more',
      'Recent activity on plant detail page',
      'Activity feed with timeline view',
    ],
  },
  {
    version: '1.1.0',
    date: '2026-03-02',
    changes: [
      'Enhanced care guides with soil recipes and propagation',
      'Bulk upgrade for existing plants',
      'Expanded care accordion sections',
    ],
  },
  {
    version: '1.0.0',
    date: '2026-02-28',
    changes: [
      'Initial release — AI plant identification, care info, and diagnosis',
    ],
  },
];
